import React, { useEffect } from "react";
import { TextWrapper, Wrapper } from "../../constants/common/StyledGlobalConstants";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import SupportingUrl from "../../constants/SupportingUrl";
import UrlRedirection from "../common/UrlRedirection";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { DESKTOP } = DEVICE_BREAKPOINTS;

const SubmitRequest = ({ windowSize, pageTitle, pageBodyText, pageBodyTextOne, pageBodyTextTwo }) => {
  const { t } = useTranslation("contractsTranslation");

  useEffect(() => {
    const htmlElement = document.querySelector("html");
    if (htmlElement) {
      htmlElement.style.overflow = "hidden";
    }
    return () => {
      const htmlElement = document.querySelector("html");
      if (htmlElement) {
        htmlElement.style.overflow = "scroll";
      }
    };
  }, []);
  

  return (
      <Wrapper
        display="inline-flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4rem"
        marginTop={windowSize.width < DESKTOP ? "1.5rem" : "3rem"}
      >
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start" gap="1.5rem">
          <h1 className="sr-only" tabIndex="-1" role="alert">{pageTitle}</h1>
          <TextWrapper aria-hidden="true" fontFamily="neue-haas-grotesk-display" fontSize="2.5rem" fontWeight="700" lineHeight="3rem">
            {pageTitle}
          </TextWrapper>
          <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
            {pageBodyText}
          </TextWrapper>
          <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
            {pageBodyTextOne}
          </TextWrapper>
          <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem">
            {pageBodyTextTwo}
            <UrlRedirection
              label={t("FAQ: Contracts and cancellations")}
              link={SupportingUrl.FAQ_ContractsAndCancellation}
              ariaLabel={`${pageBodyTextTwo} ${t("FAQ: Contracts and cancellations")}`}
            />
            {"."}
          </TextWrapper>
        </Wrapper>
      </Wrapper>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => {
  return {
    windowSize: state.ACCOUNT.windowSize,
  };
};

SubmitRequest.propTypes = {
  windowSize: PropTypes.shape({
    width: PropTypes.number,
  }),
  pageTitle: PropTypes.string,
  pageBodyText: PropTypes.string,
  pageBodyTextOne: PropTypes.string,
  pageBodyTextTwo: PropTypes.string,
};

SubmitRequest.defaultProps = {
  windowSize: {},
  pageTitle: "",
  pageBodyText: "",
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitRequest);
